import React from 'react'
import { ArticleTypes } from 'types'

import './SearchContainer.scss'
import { CrossIcon } from 'assets/icons'

interface Props {
    value?: string,
    placeholder: string,
    onInput: Function
}

interface State {
    keyword: string,
    baseMaterial: ArticleTypes.BaseMaterials[]
}

export default class SearchContainer extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)
        this.state = {
            keyword: this.props.value || '',
            baseMaterial: ['Cutting', 'Seed']
        }
    }

    public searchByKeyword = (event: KeyboardEvent, keyword: string) => {
        this.props.onInput(keyword, this.state.baseMaterial)
        // Blur input te hide mobile keyboard
        const input = document.getElementById('searchInput')
        if (input) {
            input.blur()
        }
        event.preventDefault()
    }

    public handleInput = (event: any) => {
        if (event.target.value === '') {
            this.emptyResults(event)
        } else {
            this.setState({
                keyword: event.target.value,
                baseMaterial: this.state.baseMaterial
            })
        }
    }

    public emptyResults = (event: any) => {
        this.searchByKeyword(event, '')
        this.setState({
            keyword: '',
            baseMaterial: this.state.baseMaterial
        })
    }

    public toggleChange = ( event: any, Value: ArticleTypes.BaseMaterials ) => {
        const updatedArray = this.state.baseMaterial
        const valueIndex = updatedArray.indexOf(Value)
        valueIndex > -1 ?
            updatedArray.splice(valueIndex, 1) :
            updatedArray.push(Value)

        this.setState({
            baseMaterial: updatedArray
        })

        setTimeout(() => this.searchByKeyword(event, this.state.keyword), 0)

    }

    public render() {

        const { placeholder } = this.props
        return (
            <div id="search-container">
                <form
                    // action="."
                    name="search"
                    onSubmit={(event: any) =>
                        (this.searchByKeyword(event, this.state.keyword))}
                >

                    <div className="input-row">
                        <label htmlFor="searchInput" className="u-hidden">
                            Search by keyword
                        </label>
                        <input
                            id="searchInput"
                            type="search"
                            name="keyword"
                            value={this.state.keyword}
                            placeholder={placeholder}
                            onChange={event => this.handleInput(event)}
                        />
                        { this.state.keyword &&
                            <a href="#" className="close" onClick={(event) => this.emptyResults(event)}>
                                <CrossIcon stroke="#666"/>
                            </a>
                        }
                    </div>

                    <input
                        type="checkbox"
                        id="seed"
                        checked={this.state.baseMaterial.indexOf('Seed') > -1}
                        onChange={event => {this.toggleChange(event, 'Seed')}}
                    />
                    <label htmlFor="seed">Seed</label>

                    <input
                        type="checkbox"
                        id="cutting"
                        checked={this.state.baseMaterial.indexOf('Cutting') > -1}
                        onChange={event => {this.toggleChange(event, 'Cutting')}}
                    />
                    <label htmlFor="cutting">Cuttings</label>

                </form>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/SearchContainer/index.tsx